module.exports = __webpack_public_path__ + "img/i-bg.a2e0f525.gif";